import { takeEvery } from 'redux-saga/effects';

import * as signInActions from 'store/modules/auth/signIn';
import { authorizedRouteSignIn } from './utils';

export default function* listenAuthorizedRouteSignIn() {
  yield takeEvery(signInActions.authorizedRouteSignIn.toString(), authorizedRouteSignIn);
}
